import React from 'react';
import { makeStyles, createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Chip from '@material-ui/core/Chip';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';

import history from '../../../history'

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: 200,
        maxWidth: 345,
    },
    marginTextField: {
        marginTop: theme.spacing(1)
    }
}));

const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#4caf50',
        },
        secondary: {
            main: '#f44336',
        }
    },
});

export default function CardForm(props) {
    const classes = useStyles();

    const erroEntrada = {
        icon: <CloseIcon />,
        color: 'secondary',
        isOk: false
    }

    const successEntrada = {
        icon: <CheckIcon />,
        color: 'primary',
        isOk: true
    }

    const [caracterMaiusculo, setCaracterMaiusculo] = React.useState(erroEntrada);
    const [caracterMinusculo, setCaracterMinusculo] = React.useState(erroEntrada);
    const [caracteresLength, setCaracteresLength] = React.useState(erroEntrada);
    const [numero, setNumero] = React.useState(erroEntrada);

    const [senha, setSenha] = React.useState('');
    const [confirmarSenha, setConfirmarSenha] = React.useState('');


    function verificarRegras(e) {
        checkSePossuiNumero(e.target.value)
        checkSePossuiCaracterMaiusculo(e.target.value)
        checkSePossuiCaracterMinusculo(e.target.value)
        checkSePossuiCaracteresLength(e.target.value)
    }

    function checkSePossuiNumero(value) {
        const regexNumero = /^(?=.*\d)/;
        if (regexNumero.exec(value)) {
            setNumero(successEntrada)
        } else {
            setNumero(erroEntrada)
        }
    }

    function checkSePossuiCaracterMaiusculo(value) {
        const regexCaraterMaiusculo = /^(?=.*[A-Z])/;
        if (regexCaraterMaiusculo.exec(value)) {
            setCaracterMaiusculo(successEntrada)
        } else {
            setCaracterMaiusculo(erroEntrada)
        }
    }

    function checkSePossuiCaracterMinusculo(value) {
        const regexCaraterMinusculo = /^(?=.*[a-z])/;
        if (regexCaraterMinusculo.exec(value)) {
            setCaracterMinusculo(successEntrada)
        } else {
            setCaracterMinusculo(erroEntrada)
        }
    }

    function checkSePossuiCaracteresLength(value) {
        if (value.length >= 8) {
            setCaracteresLength(successEntrada)
        } else {
            setCaracteresLength(erroEntrada)
        }
    }

    onsubmit = (event) => {
        event.preventDefault()
        if (caracterMaiusculo.isOk && caracterMinusculo.isOk && caracteresLength.isOk && numero.isOk
            && senha === confirmarSenha) {
            props.onsubmit(senha)
        } else {
            props.dispatch({
                type: 'OPEN_ALERT_DIALOG',
                title: 'Recuperação de senha',
                description: 'As senhas não são iguais, ou você não atendeu a todos os critérios da senha.'

            })
        }
    }

    return (
        <Card className={classes.root}>
            <form>
                <CardContent>
                    <Typography gutterBottom variant="h5" component="h2" align="center">
                        Alterar senha
                    </Typography>

                    <ThemeProvider theme={theme}>
                        <Grid
                            container
                            direction="row"
                            spacing={1}
                        >
                            <Grid item xs={12}>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    A senha deve conter:
                            </Typography>
                            </Grid>

                            <Grid item xs={12}>
                                <Chip
                                    variant="outlined"
                                    color={caracterMaiusculo.color}
                                    size="small"
                                    icon={caracterMaiusculo.icon}
                                    label="um caractere maiúsculo"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Chip
                                    variant="outlined"
                                    color={caracterMinusculo.color}
                                    size="small"
                                    icon={caracterMinusculo.icon}
                                    label="um caractere minúsculo"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Chip
                                    variant="outlined"
                                    color={numero.color}
                                    size="small"
                                    icon={numero.icon}
                                    label="um numero"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Chip
                                    variant="outlined"
                                    color={caracteresLength.color}
                                    size="small"
                                    icon={caracteresLength.icon}
                                    label="minimo 8 caracteres"
                                />
                            </Grid>
                        </Grid>
                    </ThemeProvider>
                    <Grid
                        container
                        direction="row"
                        justify="center"
                        alignItems="center"
                        spacing={2}
                        className={classes.marginTextField}
                    >
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                name="password"
                                label="Nova Senha"
                                type="password"
                                id="password"
                                onChange={(e) => setSenha(e.target.value)}
                                onKeyUp={(e) => verificarRegras(e)}
                                value={senha}
                                autoComplete="new-password"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                name="confirmarpassword"
                                label="Confirmar Nova Senha"
                                type="password"
                                id="confirmarpassword"
                                onChange={(e) => setConfirmarSenha(e.target.value)}
                                value={confirmarSenha}
                                autoComplete="new-password"
                            />
                        </Grid>
                    </Grid>
                </CardContent>
                <Grid
                    container
                    direction="row"
                    justify="flex-end"
                    alignItems="center"
                >
                    <CardActions>
                        <Button onClick={() => history.push('/login')} variant='outlined' color="primary">
                            Cancelar
                        </Button>
                        <Button type='submit' color="primary" variant='outlined'>
                            Enviar
                        </Button>
                    </CardActions>
                </Grid>

            </form>
        </Card>
    );
}
